export default function ({ context }) {
  const pricingUrl = 'https://pricing.gb.ru/api'
  const claimsUrl = 'https://claims.gb.ru/api/v2'
  const ordersUrl = 'https://orders.gb.ru/api/v2'

  return {
    async getPrice (productId) {
      try {
        return await context.$axios.get(`${pricingUrl}/prices/v1/s2/calculate?productIds[]=${productId}&regionIds[]=ru&prices[]=all&withPackages&withDescriptions=true`)
      } catch (e) {
        console.warn(e)

        return {
          prices: []
        }
      }
    },

    async getSpecializationsByCode (code) {
      try {
        return await context.$axios.get(`${pricingUrl}/pim-specializations?filter[directions.code][eq]=${code}`)
      } catch (e) {
        console.warn(e)

        return []
      }
    },

    async getTechSpecializations () {
      try {
        return await context.$axios.get(`${pricingUrl}/pim-tech-specializations`)
      } catch (e) {
        console.warn(e)

        return []
      }
    },

    async createClaim (payload) {
      try {
        return await context.$axios.post(`${claimsUrl}/services/webflow/create_claim`, payload)
      } catch (e) {
        console.warn(e)
      }
    },

    async sendOrder (payload) {
      try {
        return await context.$axios.post(`${ordersUrl}/update-order`,
          {
            ...payload
          }
        )
      } catch (e) {
        console.warn(e)
      }
    }
  }
}
